import { useQuery } from "react-query";
import {
	fetchCommand,
	fetchCommandActivityLogsPaginated,
	fetchCommandsPaginated,
	fetchCommandSupplyOrder,
	fetchCommandTickets,
	fetchCommandUPSTracking,
} from "../queries/command.queries";
import { PaginatedFilter } from "../types/axios.types";

export const useCommandsPaginated = ({
	filters: prefilters,
}: {
	filters?: PaginatedFilter;
}) => {
	return (
		page?: number,
		size?: number,
		search?: string,
		filters?: PaginatedFilter,
		sortBy?: string[],
	) => {
		const computedFilters = { ...prefilters, ...filters };
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const query = useQuery(
			["commands-paginated", page, size, search, computedFilters, sortBy],
			() => {
				try {
					return fetchCommandsPaginated(
						page,
						size,
						search,
						computedFilters,
						sortBy,
					);
				} catch (err) {
					return null;
				}
			},
			{ keepPreviousData: true },
		);
		return query?.data;
	};
};

export const useCommandActivityLogsPaginated = ({
	id,
}: {
	id: string | number | undefined;
}) => {
	return (
		page?: number,
		size?: number,
		search?: string,
		filters?: PaginatedFilter,
		sortBy?: string[],
	) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const query = useQuery(
			["commands-logs-paginated", id, page, size, search, filters, sortBy],
			() => {
				try {
					return fetchCommandActivityLogsPaginated(
						id,
						page,
						size,
						search,
						filters,
						sortBy,
					);
				} catch (err) {
					return null;
				}
			},
			{ keepPreviousData: true },
		);
		return query?.data;
	};
};

export const useCommand = (id: number | string | null) => {
	return useQuery(["command", id], () => {
		try {
			return fetchCommand(id);
		} catch (err) {
			return null;
		}
	});
};

export const useCommandSupplyOrder = (id: number | string | null) => {
	return useQuery(["command-supply-order", id], () => {
		try {
			return fetchCommandSupplyOrder(id);
		} catch (err) {
			return null;
		}
	});
};

export const useCommandTickets = (id: number | string | undefined) => {
	const res = useQuery(["command", "tickets", id], () => {
		try {
			return fetchCommandTickets(id);
		} catch (err) {
			return null;
		}
	});
	const tickets = res.data;

	return { tickets };
};

export const useCommandUPSTracking = (id?: number | string | null) => {
	return useQuery(["command", id, "tracking"], () => {
		try {
			return fetchCommandUPSTracking(id);
		} catch (err) {
			return null;
		}
	});
};
